import {
  brandBgDataFile,
  BrandBgDataFile,
  brandEntityId,
  BrandEntityId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgCreate1VO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgCreate1VO.validationSchema()
  );

  constructor(readonly value: RoomBrandBgCreate1) {
    JsonSchemaValidator.assert(RoomBrandBgCreate1VO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandBgDataFile
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgCreate1 {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandBgDataFile;
}
